import { matchPath, type RouteObject } from 'react-router'
import QS from 'qs'
import type { IamFeature } from '@/features/iam'
import { AuthenticatedContainer } from './AuthenticatedContainer'

/**
 * Wraps the specified routes in a pathless route which requires
 * authentication and a selected workspace.
 *
 * @param iam
 * @param routes
 */
export function authenticated(
  iam: IamFeature,
  routes: RouteObject[],
): RouteObject {
  return {
    children: routes,
    // Signing in happens on the authentication screen rather than a login
    // route, so there is nothing to redirect to.
    loader: async ({ request }) => {
      const url = new URL(request.url)
      const inviteToken = matchPath(
        '/invitation/:invitationToken',
        url.pathname,
      )?.params.invitationToken
      await iam.activate(inviteToken)
      // Not awaited, since it may redirect to the identity provider; the
      // login view renders its failure.
      iam.authenticationViewModel
        .handleParams(QS.parse(url.search, { ignoreQueryPrefix: true }))
        .catch(() => undefined)
      return null
    },
    Component: () => (
      <AuthenticatedContainer vm={iam.authenticationViewModel} />
    ),
  }
}
